// extracted by mini-css-extract-plugin
export var content = "InfoTooltip-module--content--9c456";
export var info = "InfoTooltip-module--info--a5f85";
export var tooltip = "InfoTooltip-module--tooltip--d1d8b";